import { MarkerClusterer } from "@googlemaps/markerclusterer";

var infowindow = null;
var icon = '/img/icon_map.svg';
var map, infoWindow, bounds;
let markers = [];
$(document).ready(function (e)
{
    if (document.getElementById('home_map_1'))
    {
        initMap();
        // zmianaRegionu();
        // zmianaAttsPage();
    }

    $('.pokaz_na_mapie').on('click', function() {
        
        var lat = $(this).data('lat');
        var lng = $(this).data('lng');

        var punkt = {lat:lat, lng:lng};
        map.panTo(punkt);
        map.setZoom(15);
        
        $('html, body').animate({
            scrollTop: $( "#home_map_1" ).offset().top - 250
        }, 500);    

    })

});

function initMap() {
    // var address = 'Podlaskie'; //51.919438, 19.145136
    var address = '53.402210992226465, 23.105030367041184'; //51.919438, 19.145136
    var map_styles = [
        {
            featureType: "all",
            elementType: "all",
            stylers: [
                {saturation: -100}
            ]
        }
    ];
    map = new google.maps.Map(document.getElementById('home_map_1'), {
        center: {lat: 51.919438, lng: 19.145136},
        zoom: 8,
        mapTypeControlOptions: {
            mapTypeIds: ['grayscale']
        }
    });
    var mapType = new google.maps.StyledMapType(map_styles, {name: "Grayscale"});
    map.mapTypes.set('grayscale', mapType);
    map.setMapTypeId('grayscale');

    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({address: address}, (results, status) => {
        if (status === "OK")
        {
            map.setCenter(results[0].geometry.location);
            loadMarkers(map);
        }
    });

    // pokaz / ukryj boxy ktore sa widoczne na mapce
    // google.maps.event.addListener(map, 'idle', function() {
    //     showVisibleMarkers();
    // });
}

function loadMarkers(map)
{
    var id_page = $('#home_map_1').data('id_page');

    $.get('/get/punkty-dys/'+id_page).done(function (data) {
        $.each(data, function (index, item) {
            $.each(item.dziecidys, function (index, item) {
            // for (var i = 0; i < item.dziecidys.length; i++) {
                if (typeof item.lat !== "undefined" || typeof item.lng !== "undefined")
                {
                    // console.log(item.lat);
                    // var latlang_arr = item.latlng.split(',');
                    var lat = item.lat;
                    var lng = item.lng;

                    // var name = (item.name) ? item.name : '';
                    var street = (item.street) ? item.street : item.city;
                    // var city = (item.city) ? item.city : '';
                    var planowane_od = (item.planowane_od) ? item.planowane_od : '';
                    var planowane_od_godz = (item.planowane_od_godz) ? item.planowane_od_godz : '';

                    var planowane_do = (item.planowane_do) ? item.planowane_do : '';
                    var planowane_do_godz = (item.planowane_do_godz) ? item.planowane_do_godz : '';
                    // var email = (item.email) ? item.email : '';;

                    const contentString = '<div class="info_box"><h6>' + street + '</h6><div><strong>Planowane wyłączenie:</strong></div><div>od:'+planowane_od+' godz.'+ planowane_od_godz.slice(0, -3)+'</div><div>do:'+planowane_do+' godz.'+planowane_do_godz.slice(0, -3)+'</div></div>';
                    const infowindow = new google.maps.InfoWindow({
                                            content: contentString,
                                        });
                    
                    // console.log(index + '_' + i);
                    var idd = Math.floor(Math.random() * 10000);
                    // console.log(idd);

                    var marker = new google.maps.Marker({
                        // position: new google.maps.LatLng(lat, lng),
                        position: { lat: lat, lng: lng},
                        bounds: true,
                        id: 'mk_' + index,
                        // letter: idd,
                        icon: icon,
                        map: map,
                        // region: item.wojewodztwo,
                        // attrs_page: item.attrs_page,
                        title: item.city,
                    });


                    marker.addListener("click", () => {
                        infowindow.open(map, marker);
                    })
                    markers.push(marker);
                }
            })
        });
        new MarkerClusterer({ markers, map });
    });
}

// function setMapOnAll(map, attr) {
//     for (let i = 0; i < markers.length; i++) {

//         if (attr != 'all') {
//             // console.log('znikaj')
//             if (markers[i].attrs_page && markers[i].attrs_page.indexOf(attr) >= 0 ) {
//                 markers[i].setMap(map);
//             }
//         }
//         else {
//             markers[i].setMap(map);
//         }

//     }
// }
// function setMapOnRegion(region, attr) {
//     for (let i = 0; i < markers.length; i++) {
//         if (attr != 'all') {
//             if (markers[i].attrs_page && markers[i].attrs_page.indexOf(attr) >= 0 ) {
//                 if (markers[i].region == region) {
//                     markers[i].setMap(map);
//                 }
//             }

//         }
//         else {

//             if (markers[i].region == region)
//                 markers[i].setMap(map);
//         }
//     }
// }

// function filtrujListe(nazwa, attr)
// {
//     if (nazwa != 'Polska')
//     {
//         setMapOnAll(null, attr);
//         $('#map_points_cards .point-card').addClass('hidden-region');

//         if (attr == 'all') {
//             $('#map_points_cards .point-card[data-wojewodztwo=' + nazwa + ']').removeClass('hidden-region').addClass('selected-region');
//         }else {
//             var elemnty = $('#map_points_cards .point-card[data-wojewodztwo=' + nazwa + ']');

//             for (var i = 0; i < elemnty.length; i++) {
//                 if ( $(elemnty[i]).data('attrpage') && $(elemnty[i]).data('attrpage').indexOf(attr) >= 0 ) {
//                     $(elemnty[i]).removeClass('hidden-region').addClass('selected-region');
//                 }
//             }


//             // $('#map_points_cards .point-card[data-wojewodztwo=' + nazwa + '][data-attrpage='+ ']').removeClass('hidden-region').addClass('selected-region');
//         }

//     } else
//     {
//         setMapOnAll(map, attr);
//         if (attr == 'all') {
//             $('#map_points_cards .point-card').removeClass('hidden-region').removeClass('selected-region');
//         }else {
//             $('#map_points_cards .point-card').addClass('hidden-region');
//             var elemnty = $('#map_points_cards .point-card');

//             for (var i = 0; i < elemnty.length; i++) {
//                 if ( $(elemnty[i]).data('attrpage') && $(elemnty[i]).data('attrpage').indexOf(attr) >= 0 ) {
//                     $(elemnty[i]).removeClass('hidden-region').addClass('selected-region');
//                 }
//             }
//         }
//     }

// }

// function geocoder(address, attr) {
//     const geocoder = new google.maps.Geocoder();
//         geocoder.geocode({address: address}, (results, status) => {
//             if (status === "OK")
//             {
//                 //map.setCenter(results[0].geometry.location);
//                 //var bounds = new google.maps.LatLngBounds();
//                 // if (address != 'Polska')
//                 // {
//                     // var northeast = {lat: results[0].geometry.viewport.Ua.i, lng: results[0].geometry.viewport.La.g};
//                     // var southwest = {lat: results[0].geometry.viewport.Ua.g, lng: results[0].geometry.viewport.La.i};

//                     //var northeast = {lat: results[0].geometry.viewport.oc.i, lng: results[0].geometry.viewport.Eb.g};
//                     //var southwest = {lat: results[0].geometry.viewport.oc.g, lng: results[0].geometry.viewport.Eb.i};
//                     //bounds.extend(northeast);
//                     //bounds.extend(southwest);
//                     let bounds = results[0].geometry.bounds;
//                     map.fitBounds(bounds);
//                     setMapOnRegion(address, attr);
//                 // } else
//                 // {
//                 //     map.setCenter({lat: 51.919438, lng: 19.145136});
//                 //     map.setZoom(6);
//                 // }

//             }
//         });
// }

// function zmianaRegionu()
// {
//     $('#zmien_region').change(function (e)
//     {
//         // var address = $(this).val();
//         var address = $('#zmien_region').val();
//         var attr = $('#zmien_attrs').val();
//         if (!attr) {
//             attr = 'all';
//         }

//         czyszczenieMarkerow();

//         filtrujListe(address, attr);

//         geocoder(address, attr);
        

//     });
// }


// function zmianaAttsPage()
// {
//     $('#zmien_attrs').change(function (e)
//     {
//         var address = $('#zmien_region').val();
//         var attr = $('#zmien_attrs').val();

//         czyszczenieMarkerow();

//         filtrujListe(address, attr);

//         geocoder(address, attr);
//     });
// }

// function czyszczenieMarkerow() {
//     for (let i = 0; i < markers.length; i++) {
//         markers[i].setMap(null);
//     }
// }




$('#addressInput').on('input', function() {
    var input = document.getElementById('addressInput');

    const options = {
        types: ['(cities)'],
        componentRestrictions: {country: "pl"}
    };

    var autocomplete = new google.maps.places.Autocomplete(input, options);

    autocomplete.setFields(["geometry"])
    google.maps.event.addListener(autocomplete, 'place_changed', function () {
        var place = autocomplete.getPlace();

        map.fitBounds(place.geometry.viewport);
        map.setZoom(12);
        // showVisibleMarkers();
    });
})

// function showVisibleMarkers() {
//     var bounds = map.getBounds();
//     // var count = 0;
                                   
//     for (var i = 0; i < markers.length; i++) {
//         var marker = markers[i];
//         var infoPanel = $('.info-' + i );
                                           
//         if(bounds.contains(marker.getPosition())===true) {
//             infoPanel.show();
//             // count++;
//         }
//         else {
//             infoPanel.hide();
//         }
//     }
    
//     // $('#infos').html(count);
// }